var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClasses},[_c('o-datepicker-control',{ref:"picker",attrs:{"typeable":false,"readonly":false,"disabled":false,"clear":false},on:{"input":_vm.updated},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }